import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import ReportingDashboard from './listing/ReportingDashboard';
import Reportingcreation from './listing/ReportingCreation';

const ReportingRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<ReportingDashboard/>} />
            <Route path="/creation/:id?" element={<Reportingcreation/>} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
};

export default ReportingRoutes;
